import { SokoCoinIcon } from '@/app/components/SvgIcons';

interface Props {
    value: number;
    size?: number;
    className?: string;
}

/**
 * A Soko Points amount with the green coin next to it. Soko Points are always
 * shown with the coin rather than a "SP" suffix, so they read the same here as
 * in the wallet and the exchange.
 */
export default function SokoAmount({ value, size = 14, className = '' }: Props) {
    return (
        <span className={`inline-flex items-center gap-1 tabular-nums ${className}`}>
            {value.toLocaleString()}
            <SokoCoinIcon size={size} />
        </span>
    );
}
